<template>
  <div class="w-full   bg-gray-50 overflow-y-auto "
    :class2="{ 'w-96' :(items?.length < 2), 'w-64' :(items?.length ==2), 'w-96' :(items?.length > 2), }"
    :class="{ 'w-72' :(items?.length < 2), 'w-72' :(items?.length ==2), 'w-72' :(items?.length > 2), }">
    <div
      class="px-3 py-2 bg-gray-700 border-b border-gray-200 rounded-t-lg   w-full">
      <h3 class="font-bold  text-white">
        Détails
      </h3>
    </div>
    <div class="px-2 py-2 flex flex-col w-full border-b border-b-gray-300" v-for="cell in items" :key="cell.id">



      <div class="grid grid-cols-1  text-sm   font-normal h-full flex flex-row items-center px-1 ">
 
        <div v-if="cell.state == 'DONE'">
          <div class="flex flex-row items-center" v-for="room in cell.rooms" :key="room._id">
            <div class="flex justify-center w-10 pr-2 ">
              <i v-if="room.state == 'OK'" class="fa-regular fa-check text-green-800" />
              <i v-if="room.state == 'KO'" class="fa-regular fa-x text-red-800" />
            </div>
            <span>{{room.name}}</span>

          </div>
        </div>
        <div v-if="cell.state == 'NOT-DONE'" class="flex flex-row items-center  font-normal">
          <span>{{cell.reason_label}}</span>
        </div>

      </div>


      <div
        class=" text-sm   font-normal h-full flex flex-row items-center px-1 mt-3 border-t border-t-1 border-t-gray-300">

      </div>

      <div class=" text-sm   mt-2 font-normal h-full flex flex-row items-center px-1 ">
        <div class="flex justify-center w-10 pr-2 ">
          <i class="fa-regular fa-clock"></i>
        </div>



        <span class="font-semibold">{{ formatDateTime(cell?.done_at) }}</span>
      </div>
      <div class="text-sm font-normal flex flex-row items-center px-1  h-full">
        <div class="flex justify-center w-10 pr-2 ">
          <i class="fa-regular fa-user  " />
        </div>
        <span class="font-semibold">{{ cell?.user?.name }}</span>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'FileColDisplayCleaningPlan',
    components: {},
    methods:
    {
      formatDateTime: function (date) {
        if (date == undefined) return "";
        if (date == "") return "";
        if (date == "null") return "";
        if (date == "--") return "";

        var myDate = new Date(date);

        const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        let formatteddate = myDate.toLocaleString('fr-FR', options);

        //  return date
        return formatteddate
      }
    },
    props: {
      items: Array
    },
    data() {
      return {}
    }
  }

</script>